import React from 'react';

const TopLine = () => (
  <svg width="273" height="119" viewBox="0 0 273 119" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.91034C6.05547 22.1599 20.9095 40.855 34.3889 57.1373C44.9378 69.8798 56.8155 82.5039 68.4444 94.4611C75.5276 101.744 83.9332 107.159 93.4444 111.555C98.7104 113.989 105.845 117.513 112 117.877C128.506 118.853 145.352 113.892 160.167 107.762C174.018 102.031 188.4 94.2826 197.722 83.0313C207.36 71.399 214.582 58.2911 224.889 47.0731C234.423 36.6955 246.86 30.1877 258.444 22.0389C264.93 17.4764 267.646 12.0596 270 5.09651C270.582 3.37313 272 2.82648 272 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default TopLine;
